export const CREATE_A_FUNCTION_THAT_TEXT = "Create a function that ";

// Local storage keys

export enum LOCAL_STORAGE_KEYS {
  BannerNotifyWhenChatCreationReady = "banner.notify-when-chat-creation-ready",
  RunHideAreYouSureDialog = "run.hide-alert-dialog",
  CookieConsent = "cookie_consent",
}

export enum COOKIE_KEYS {
  NavbarExpanded = "navbar.expanded",
}

export type LOCAL_STORAGE_ITEM = {
  value: {
    [key: string]: unknown;
  };
  timestamp: number;
};

// Users

export const CODEWORDS_LIBRARY_USER_ID = "0xae6b9324e";

// Urls

export const CODEWORDS_BASE_URL = "https://codewords.agemo.ai";
export const CODEWORDS_STAGING_BASE_URL = "https://codewords-staging.agemo.ai";
export const CODEWORDS_LOCAL_BASE_URL = "http://localhost:3001";

// Attio

export const ATTIO_OBJECT_ID_INTEREST_IN_CHAT_CREATION =
  "25f10db1-b548-470c-8d76-a308c36ffc2d";
